import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function mySessionsGroupReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.MY_SESSIONS_GROUP_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.MY_SESSIONS_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.MY_SESSIONS_GROUP_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
